export const dashboardTranslations = {
  en: {
    versus: "Versus",
    loading: "Loading...",
    most_viewed: "Most Viewed",
    oldest_first: "Oldest First",
    newest_first: "Newest First",
    sort: "Sort",
    most_view: "Most View",
    no_user_logged_in: "No user logged in.",
    error_loading_profile: "Error loading profile.",
    failed_to_load_profile_view_stats: "Failed to load profile view stats.",
    failed_to_load_dashboard_data: "Failed to load dashboard data.",
    manager_request: "Manager Request",
    manager_request_content: "wants to add himself as a manager to you",
    accept: "Accept",
    decline: "Decline",
    total_profile_views: "Total Profile Views",
    seven_days: "7 Days",
    one_month: "1 Month",
    all: "All",
    profile_views_by_country: "Profile Views by Country",
    card_views_by_country: "Card Views by Country",
    views: "views",
    countries: "Countries",
    not_specified: "Not specified",
    click_profile_or_card_to_view_analytics: "Click Profile or Card to view analytics",
    accepted: "Request Accepted successfully",
    declined: "Request Declined successfully",
    description: "Post Description",
    title: "Title",
    startPost: "What’s on your mind?",
    post: "Post",
    photo: "Photo",
    video: "Video",
    posting: "Posting...",
    empty: "Please add a title, text, or media before posting.",
    title_required: "Please enter a title before posting.",
    success: "Post created successfully!",
    error: "Something went wrong.",

    deal_id: "Deal ID",
    deal_type: "Deal Type",
    status: "Status",
    price: "Price",
    currency: "Currency",
    sport: "Sport",
    location: "Location",
    event_date: "Event Date",
    received_amount: "Received Amount",
    paid_at: "Paid At",
    no_closed_deal_payments: "No closed deal payments available.",
    go_to_deals: "Go To Deals",
    active_deal: "Active Deal",
    closed_deal: "Closed Deal",
    loading_active_deals: "Loading active deals...",
    created_at: "Created At",
    fighter: "Fighter",
    manager: "Manager",
    refund: "Refund",
    deal_types: {
      FIGHT_SINGLE: "Fight Single",
      FIGHT_TOURNAMENT: "Fight Tournament",
      SPARRING: "Sparring",
    },
    deal_status: {
      PROPOSED: "Proposed",
      ACCEPTED: "Accepted",
      CONFIRMED: "Confirmed",
      WAITING_FOR_RESULT: "Waiting for result",
      RESULT_UPDATED: "Result updated",
      RESULT_CONFIRMED: "Result confirmed",
      FIGHTER_RATED: "Fighter rated",
      MANAGER_RATED: "Manager rated",
      FINISHED: "Finished",
      CANCELLED: "Cancelled",
      REJECTED: "Rejected",
      DISPUTE: "Dispute",
    },
    total_income: "Total Income",
    total_refund: "Total Refund",
    total_expense: "Total Expense",
    total_deals: "Total Deals",
    expense_amount: "Expense Amount",
    income: "Income",
    expense: "Expense",
    deals: "Deals",
    money_flow: "Money Flow",
    failed_to_load_money_flow: "Failed to load money flow data.",

    money_projection: "Money Projection",
    projected: "Projected",
    funded: "Funded",
    net_paid: "Net Paid",
    pending: "Pending",
    refunded: "Refunded",
    cancelled: "Cancelled",
    select_bout: "Select a bout to view details",
    bout_total: "Bout total",
    breakdown: "Breakdown",
    red: "Red",
    blue: "Blue",
    select_event: "Select an event",
    choose_event_left: "Choose an event from the left list to view its breakdown.",
    select_bout_funding: "Select a bout to view its full funding breakdown",
    events_title: "Events",
    dashboard_title: "Dashboard",
    no_deals_to_display: "No deals to display",
    no_data_to_display: "No data to display",
    total_funds: "Total funds",
    paid: "Paid",
    project_costs: "Project costs",
    remaining_balance: "Remaining balance",
    total_events: "Total events",
    draft_events: "Draft events",
    active_events: "Active events",
    events_completed: "Events completed",
    failed_to_load_total_funds: "Failed to load total funds.",
    failed_to_load_event_stats: "Failed to load event stats.",
    from_last_month: "From last month",
    marketplace_cards: "Marketplace cards",
    failed_to_load_fighter_stats: "Failed to load fighter stats.",
    failed_to_load_marketplace_cards: "Failed to load marketplace cards.",
    insights: "Insights",
    current_events: "Current events",
    failed_to_load_insights: "Failed to load insights.",
    failed_to_load_current_events: "Failed to load current events.",
    previous_slide: "Previous",
    next_slide: "Next",
    events_subtitle: "events · tap any row to view its full details",
    search_events: "Search events...",
    no_events_found: "No events found",
    beta_banner_message: "This app is in beta stage. If you encounter any issues, please share your feedback to help us improve.",
    close: "Close"
  },

  de: {
    versus: "Gegen",
    loading: "Laden...",
    most_viewed: "Am meisten angesehen",
    oldest_first: "Älteste zuerst",
    newest_first: "Neueste zuerst",
    sort: "Sortieren",
    most_view: "Meist angesehen",
    no_user_logged_in: "Kein Benutzer angemeldet.",
    error_loading_profile: "Fehler beim Laden des Profils.",
    failed_to_load_profile_view_stats: "Fehler beim Laden der Profilansichtsstatistiken.",
    failed_to_load_dashboard_data: "Fehler beim Laden der Dashboard-Daten.",
    manager_request: "Manager-Anfrage",
    manager_request_content: "möchte sich selbst als Manager zu Ihnen hinzufügen",
    accept: "Akzeptieren",
    decline: "Ablehnen",
    total_profile_views: "Gesamtprofilansichten",
    seven_days: "7 Tage",
    one_month: "1 Monat",
    all: "Alle",
    profile_views_by_country: "Profilansichten nach Land",
    card_views_by_country: "Kartenansichten nach Land",
    views: "Ansichten",
    countries: "Länder",
    not_specified: "Nicht angegeben",
    click_profile_or_card_to_view_analytics: "Klicken Sie auf Profil oder Karte, um Analysen anzuzeigen",
    accepted: "Anfrage erfolgreich akzeptiert",
    declined: "Anfrage erfolgreich abgelehnt",
    description: "Beitragsbeschreibung",
    title: "Titel",
    startPost: "Was geht dir durch den Kopf?",
    post: "Posten",
    photo: "Foto",
    video: "Video",
    posting: "Posten...",
    empty: "Bitte fügen Sie einen Titel, Text oder Medien hinzu, bevor Sie posten.",
    title_required: "Bitte geben Sie vor dem Posten einen Titel ein.",
    success: "Post erfolgreich erstellt!",
    error: "Etwas ist schiefgelaufen.",

    deal_id: "Deal-ID",
    deal_type: "Deal-Typ",
    status: "Status",
    price: "Preis",
    currency: "Währung",
    sport: "Sport",
    location: "Ort",
    event_date: "Veranstaltungsdatum",
    received_amount: "Eingegangener Betrag",
    paid_at: "Bezahlt am",
    no_closed_deal_payments: "Keine abgeschlossenen Deal-Zahlungen verfügbar.",
    go_to_deals: "Zu den Deals",
    active_deal: "Aktiver Deal",
    closed_deal: "Abgeschlossener Deal",
    loading_active_deals: "Aktive Deals werden geladen...",
    created_at: "Erstellt am",
    fighter: "Kämpfer",
    manager: "Manager",
    refund: "Rückerstattung",
    deal_types: {
      FIGHT_SINGLE: "Einzelkampf",
      FIGHT_TOURNAMENT: "Kampfturnier",
      SPARRING: "Sparring",
    },
    deal_status: {
      PROPOSED: "Vorgeschlagen",
      ACCEPTED: "Akzeptiert",
      CONFIRMED: "Bestätigt",
      WAITING_FOR_RESULT: "Wartet auf Ergebnis",
      RESULT_UPDATED: "Ergebnis aktualisiert",
      RESULT_CONFIRMED: "Ergebnis bestätigt",
      FIGHTER_RATED: "Kämpfer bewertet",
      MANAGER_RATED: "Manager bewertet",
      FINISHED: "Abgeschlossen",
      CANCELLED: "Storniert",
      REJECTED: "Abgelehnt",
      DISPUTE: "Streitfall",
    },
    total_income: "Gesamteinnahmen",
    total_refund: "Gesamtrückerstattung",
    total_expense: "Gesamtausgaben",
    total_deals: "Gesamtanzahl Deals",
    expense_amount: "Ausgabenbetrag",
    income: "Einnahmen",
    expense: "Ausgabe",
    deals: "Deals",
    money_flow: "Geldfluss",
    failed_to_load_money_flow: "Fehler beim Laden des Geldflusses.",

    money_projection: "Geldprojektion",
    projected: "Projiziert",
    funded: "Finanziert",
    net_paid: "Nettobezahlt",
    pending: "Ausstehend",
    refunded: "Rückerstattet",
    cancelled: "Storniert",
    select_bout: "Wählen Sie einen Kampf aus, um Details anzuzeigen",
    bout_total: "Kampf Gesamtsumme",
    breakdown: "Aufschlüsselung",
    red: "Rot",
    blue: "Blau",
    select_event: "Veranstaltung auswählen",
    choose_event_left: "Wählen Sie eine Veranstaltung aus der linken Liste, um die Aufschlüsselung anzuzeigen.",
    select_bout_funding: "Wählen Sie einen Kampf aus, um die Finanzierungsaufschlüsselung anzuzeigen",
    events_title: "Veranstaltungen",
    dashboard_title: "Dashboard",
    no_deals_to_display: "Keine Deals zum Anzeigen",
    no_data_to_display: "Keine Daten zum Anzeigen",
    total_funds: "Gesamtmittel",
    paid: "Bezahlt",
    project_costs: "Projektkosten",
    remaining_balance: "Verbleibendes Guthaben",
    total_events: "Veranstaltungen gesamt",
    draft_events: "Entwurfsveranstaltungen",
    active_events: "Aktive Veranstaltungen",
    events_completed: "Abgeschlossene Veranstaltungen",
    failed_to_load_total_funds: "Fehler beim Laden der Gesamtmittel.",
    failed_to_load_event_stats: "Fehler beim Laden der Veranstaltungsstatistik.",
    from_last_month: "Gegenüber dem Vormonat",
    marketplace_cards: "Marktplatzkarten",
    failed_to_load_fighter_stats: "Fehler beim Laden der Kämpferstatistik.",
    failed_to_load_marketplace_cards: "Fehler beim Laden der Marktplatzkarten.",
    insights: "Einblicke",
    current_events: "Aktuelle Veranstaltungen",
    failed_to_load_insights: "Fehler beim Laden der Einblicke.",
    failed_to_load_current_events: "Fehler beim Laden der aktuellen Veranstaltungen.",
    previous_slide: "Zurück",
    next_slide: "Weiter",
    events_subtitle: "Veranstaltungen · Tippen Sie auf eine Zeile, um Details anzuzeigen",
    search_events: "Veranstaltungen suchen...",
    no_events_found: "Keine Veranstaltungen gefunden",
    beta_banner_message: "Diese App befindet sich in der Beta-Phase. Wenn Sie auf Probleme stoßen, teilen Sie uns bitte Ihr Feedback mit, damit wir uns verbessern können.",
    close: "Schließen"
  },

  hr: {
    versus: "Protiv",
    loading: "Učitavanje...",
    most_viewed: "Najviše pregledano",
    oldest_first: "Najstarije prvo",
    newest_first: "Najnovije prvo",
    sort: "Sortiraj",
    most_view: "Najgledanije",
    no_user_logged_in: "Nema prijavljenog korisnika.",
    error_loading_profile: "Pogreška pri učitavanju profila.",
    failed_to_load_profile_view_stats: "Neuspješno učitavanje statistika pregleda profila.",
    failed_to_load_dashboard_data: "Neuspješno učitavanje podataka nadzorne ploče.",
    manager_request: "Zahtjev menadžera",
    manager_request_content: "želi se dodati kao menadžer kod vas",
    accept: "Prihvati",
    decline: "Odbij",
    total_profile_views: "Ukupni pregledi profila",
    seven_days: "7 dana",
    one_month: "1 mjesec",
    all: "Svi",
    profile_views_by_country: "Pregledi profila po zemljama",
    card_views_by_country: "Pregledi kartica po zemljama",
    views: "pregledi",
    countries: "Zemlje",
    not_specified: "Nije navedeno",
    click_profile_or_card_to_view_analytics: "Kliknite na profil ili karticu za prikaz analitike",
    accepted: "Zahtjev je uspješno prihvaćen",
    declined: "Zahtjev je uspješno odbijen",
    description: "Opis objave",
    title: "Naslov",
    startPost: "Što ti je na umu?",
    post: "Objavi",
    photo: "Fotografija",
    video: "Video",
    posting: "Objavljivanje...",
    empty: "Dodajte naslov, tekst ili medij prije objave.",
    title_required: "Unesite naslov prije objave.",
    success: "Objava je uspješno kreirana!",
    error: "Nešto je pošlo po zlu.",

    deal_id: "ID dogovora",
    deal_type: "Vrsta dogovora",
    status: "Status",
    price: "Cijena",
    currency: "Valuta",
    sport: "Sport",
    location: "Lokacija",
    event_date: "Datum događaja",
    received_amount: "Primljeni iznos",
    paid_at: "Plaćeno",
    no_closed_deal_payments: "Nema dostupnih plaćanja za zatvorene dogovore.",
    go_to_deals: "Idi na dogovore",
    active_deal: "Aktivni dogovor",
    closed_deal: "Zatvoreni dogovor",
    loading_active_deals: "Učitavanje aktivnih dogovora...",
    created_at: "Kreirano",
    fighter: "Borac",
    manager: "Menadžer",
    refund: "Povrat",
    deal_types: {
      FIGHT_SINGLE: "Pojedinačna borba",
      FIGHT_TOURNAMENT: "Turnirska borba",
      SPARRING: "Sparing",
    },
    deal_status: {
      PROPOSED: "Predloženo",
      ACCEPTED: "Prihvaćeno",
      CONFIRMED: "Potvrđeno",
      WAITING_FOR_RESULT: "Čeka se rezultat",
      RESULT_UPDATED: "Rezultat ažuriran",
      RESULT_CONFIRMED: "Rezultat potvrđen",
      FIGHTER_RATED: "Borac ocijenjen",
      MANAGER_RATED: "Manager ocijenjen",
      FINISHED: "Završeno",
      CANCELLED: "Otkazano",
      REJECTED: "Odbijeno",
      DISPUTE: "Spor",
    },
    total_income: "Ukupni prihod",
    total_refund: "Ukupni povrat",
    total_expense: "Ukupni trošak",
    total_deals: "Ukupno dogovora",
    expense_amount: "Iznos troška",
    income: "Prihod",
    expense: "Trošak",
    deals: "Dogovori",
    money_flow: "Novčani tijek",
    failed_to_load_money_flow: "Neuspješno učitavanje novčanog tijeka.",

    money_projection: "Projekcija novca",
    projected: "Projektirano",
    funded: "Financirano",
    net_paid: "Neto plaćeno",
    pending: "Na čekanju",
    refunded: "Vraćeno",
    cancelled: "Otkazano",
    select_bout: "Odaberite borbu za prikaz pojedinosti",
    bout_total: "Ukupno za borbu",
    breakdown: "Raščlamba",
    red: "Crveni",
    blue: "Plavi",
    select_event: "Odaberite događaj",
    choose_event_left: "Odaberite događaj s popisa s lijeve strane za prikaz raščlambe.",
    select_bout_funding: "Odaberite borbu za prikaz potpune raščlambe financiranja",
    events_title: "Događaji",
    dashboard_title: "Nadzorna ploča",
    no_deals_to_display: "Nema dogovora za prikaz",
    no_data_to_display: "Nema podataka za prikaz",
    total_funds: "Ukupna sredstva",
    paid: "Plaćeno",
    project_costs: "Troškovi projekta",
    remaining_balance: "Preostalo stanje",
    total_events: "Ukupno događaja",
    draft_events: "Događaji u nacrtu",
    active_events: "Aktivni događaji",
    events_completed: "Završeni događaji",
    failed_to_load_total_funds: "Neuspješno učitavanje ukupnih sredstava.",
    failed_to_load_event_stats: "Neuspješno učitavanje statistike događaja.",
    from_last_month: "U odnosu na prošli mjesec",
    marketplace_cards: "Kartice tržnice",
    failed_to_load_fighter_stats: "Neuspješno učitavanje statistike borca.",
    failed_to_load_marketplace_cards: "Neuspješno učitavanje kartica tržnice.",
    insights: "Uvidi",
    current_events: "Trenutni događaji",
    failed_to_load_insights: "Neuspješno učitavanje uvida.",
    failed_to_load_current_events: "Neuspješno učitavanje trenutnih događaja.",
    previous_slide: "Prethodno",
    next_slide: "Sljedeće",
    events_subtitle: "događaja · dodirnite redak za prikaz pojedinosti",
    search_events: "Pretraži događaje...",
    no_events_found: "Nije pronađen nijedan događaj",
    beta_banner_message: "Ova aplikacija je u beta fazi. Ako naiđete na bilo kakve probleme, podijelite svoje povratne informacije kako bismo se mogli poboljšati.",
    close: "Zatvori"
  }
};
